import Swiper, {Navigation, Pagination, EffectFade, Controller, Autoplay} from 'swiper';
Swiper.use([Navigation, Pagination, EffectFade, Controller, Autoplay]);

const settings = {
    highlightedSlider: {
        slider: '[js-highlighted-slider]',
        prev: '[js-highlighted-slider-prev]',
        next: '[js-highlighted-slider-next]',
        pagination: '[js-highlighted-slider-pagination]',
        bulletClass: 'highlighted-slider__pagination__bullet',
        bulletActiveClass: 'highlighted-slider__pagination__bullet--active'
    },
    latest: {
        slider: '[js-latest-slider]',
        noSwipingClass: 'no-swipe'
    },
    offers: {
        slider: '[js-offers-slider]',
    },
    program: {
        container: '[js-program-slider-container]',
        slider: '[js-program-slider]',
        prev: '[js-program-slider-prev]',
        next: '[js-program-slider-next]',
        sliderClass: 'program-slider',
        prevClass: 'program-slider-prev',
        nextClass: 'program-slider-next'
    },
    partners: {
        container: '[js-partners-slider-container]',
        slider: '[js-partners-slider]',
        prev: '[js-partners-slider-prev]',
        next: '[js-partners-slider-next]',
        pagination: '[js-partners-slider-pagination]',
    },
    breakpoints: {
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200
    }
}

/**
 * Highlighted slider
 * @type {Swiper}
 */
const highlightedSlider = new Swiper(settings.highlightedSlider.slider, {
    slidesPerView: 1,
    loop: true,
    autoplay: {
        delay: 4000,
    },
    spaceBetween: 20,
    navigation: {
        nextEl: settings.highlightedSlider.next,
        prevEl: settings.highlightedSlider.prev,
    },
    pagination: {
        el: settings.highlightedSlider.pagination,
        type: 'bullets',
        clickable: true
    }
});

/**
 * Program slider
 * @type {Swiper}
 */
const latestEvents = new Swiper(settings.latest.slider, {
    slidesPerView: 'auto',
    spaceBetween: 11,
    freeMode: true,
    centeredSlides: false,
    noSwipingClass: settings.latest.noSwipingClass,
    noSwiping: false,
    breakpoints: {
        [settings.breakpoints.md]: {
            spaceBetween: 24,
            noSwiping: false,
            slidesPerView: 2.2,
        },
        [settings.breakpoints.xl]: {
            spaceBetween: 24,
            noSwiping: true,
            slidesPerView: 3,
        }
    },
});

let offersSlider = null;

const initOffersSlider = () => {
    offersSlider = new Swiper(settings.offers.slider, {
        slidesPerView: 'auto',
        spaceBetween: 11,
        freeMode: true,
        centeredSlides: false,
    });
};

const destroyOffersSlider = () => {
    offersSlider.destroy(false);
    offersSlider = null;
};

const toggleOffersSlider = () => {
    if(!document.querySelector(settings.offers.slider)){
        return
    }

    if (window.innerWidth > 719 && null !== offersSlider) {
        destroyOffersSlider();
    } else if (window.innerWidth <= 719 && null === offersSlider) {
        initOffersSlider();
    }
};

toggleOffersSlider();

window.addEventListener('resize', () => {
    toggleOffersSlider();
});


/**
 * Program slider
 * @type {Swiper}
 */
const allProgramsSliderContainer = document.querySelectorAll(settings.program.container);

//Vu qu'on peut avoir plusieurs fois le même slider sur une page, il faut les instancier différemment
if (allProgramsSliderContainer.length) {
    allProgramsSliderContainer.forEach((container, i) => {
        const slider = container.querySelector(settings.program.slider);
        const prev = container.querySelector(settings.program.prev);
        const next = container.querySelector(settings.program.next);

        const program = new Swiper(slider, {
            slidesPerView: 2,
            spaceBetween: 16,
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            breakpoints: {
                [settings.breakpoints.md]: {
                    spaceBetween: 24,
                    slidesPerView: 3
                }
            },
        });

    })
}

/**
 * Partners slider
 * @type {Swiper}
 */
const allPartnersSliderContainer = document.querySelectorAll(settings.partners.container);

//Vu qu'on peut avoir plusieurs fois le même slider sur une page, il faut les instancier différemment
if (allPartnersSliderContainer.length) {
    allPartnersSliderContainer.forEach((container, i) => {
        const slider = container.querySelector(settings.partners.slider);
        const prev = container.querySelector(settings.partners.prev);
        const next = container.querySelector(settings.partners.next);

        const partners = new Swiper(slider, {
            slidesPerView: 1.2,
            spaceBetween: 11,
            centeredSlides: false,
            freeMode: true,
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            breakpoints: {
                [settings.breakpoints.sm]: {
                    slidesPerView: 3,
                },
                [settings.breakpoints.lg]: {
                    spaceBetween: 24,
                    slidesPerView: 4,
                },
                [settings.breakpoints.xl]: {
                    slidesPerView: 5,
                },
            },
        });

    })
}

